<template>
    <div class="h-full relative min-w-0 flex-1 snap-end">
        <div
            v-if="showLeft"
            class="absolute inset-y-0 left-0 w-15 z-10 bg-gradient-to-r from-white to-transparent dark:from-gray-800 pointer-events-none"
            aria-hidden="true"
        ></div>

        <div
            v-if="showRight"
            class="absolute inset-y-0 right-0 w-15 z-10 bg-gradient-to-l from-white to-transparent dark:from-gray-800 pointer-events-none"
        ></div>

        <div
            ref="scrollEl"
            class="pl-5 max-w-min h-full pr-4 flex items-center custom-scroll-x-w-0"
        >
            <div
                class="flex gap-1"
                v-for="(item, index) in breadCrumbsStore.items"
                :key="index"
            >
                <ArrowChevronRightIcon
                    v-if="index"
                    class="ml-1 text-gray-370 dark:text-white"
                />

                <div
                    v-if="BCLength === (index + 1)"
                    class="text-xs text-gray-200 whitespace-nowrap"
                >
                    {{ item.title }}
                </div>

                <div
                    v-else
                    class="text-xs text-gray-370 dark:text-white cursor-pointer whitespace-nowrap"
                    @click="backAction(item, index)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, useTemplateRef, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useScrollShadow } from '@/composables/useScrollShadow'

import ArrowChevronRightIcon from '@/components/icons/arrow/ArrowChevronRightIcon.vue'

import { useBreadCrumbsStore } from '@/store/breadCrumbsStore'

const router = useRouter()

const breadCrumbsStore = useBreadCrumbsStore()

const scrollEl = useTemplateRef('scrollEl')

const { showLeft, showRight } = useScrollShadow(scrollEl)

const BCLength = computed(() => breadCrumbsStore.items.length)

function backAction(item, index) {
    if (item.hasOwnProperty('routeName')) {
        router.push({ name: item.routeName })
    } else {
        breadCrumbsStore.goBackByIndex(index)
    }
}

function scrollToRight() {
    setTimeout(() => {
        if (scrollEl.value) {
            scrollEl.value.scrollTo({ top: 0, left: 9999, behavior: 'smooth' })
        }
    }, 100)
}

watch(() => breadCrumbsStore.items, () => {
    scrollToRight()
}, { deep: true })
</script>
